import axios from 'axios';
import { DATAMASTER_ENDPOINT } from 'common/endpoints';

export async function massiveUpdatePrices(brands, models, percentage){
  try {
    return await axios.post(`${DATAMASTER_ENDPOINT}/massiveUpdatePrices`,{brands, models ,percentage})
  } catch (error) {
    throw new Error(error)
  }
}